import "./styles/global.css?__remix_sideEffect__";

import { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import FingerprintSDK from '@cx-sdk/fp';
import { cssBundleHref } from '@remix-run/css-bundle';
import { type LinksFunction } from '@remix-run/node';
import { useLoaderData } from '@remix-run/react';
import { withSentry } from '@sentry/remix';
import { createInstance } from 'i18next';

import { AuthModalProvider } from './providers/auth-modal-provider';
import {
  FeatureFlagProvider,
  featureFlags } from
'./providers/feature-flag-provider';
import Body from './body';
import Head from './head';
import { type loader } from './root-loader';

export { loader } from './root-loader';
export { RootErrorBoundary as ErrorBoundary } from './root-error-boundary';

export const links: LinksFunction = () => [
...(cssBundleHref ? [{ rel: 'stylesheet', href: cssBundleHref }] : [])];


const i18n = await createInstance();

function App() {
  const loaderData = useLoaderData<typeof loader>();
  const { featureToggleDefinitions, lng, resources } = loaderData;

  i18n.init({
    lng,
    fallbackLng: 'en-US',
    defaultNS: 'label',
    resources
  });

  useEffect(() => {
    const fingerprintingEnabled = featureToggleDefinitions.find(
      (def) => def.name === featureFlags.SUBS__FINGERPRINTING
    );
    if (!fingerprintingEnabled) {
      return;
    }

    async function fingerprintClient() {
      if (localStorage && !localStorage.getItem('fpsdk-set')) {
        try {
          const fingerprintSDK = await FingerprintSDK.load();
          const result = await fingerprintSDK.get();
          const response = await fetch('/api/cx/fp', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(result)
          });
          const payload = (await response.json()) as {visitorId: string;};
          if (payload.visitorId) {
            localStorage.setItem('fpsdk-set', payload.visitorId);
          }
        } catch (error) {}
      }
    }
    fingerprintClient();
  }, [featureToggleDefinitions]);

  return (
    <I18nextProvider i18n={i18n}>
			<html lang={lng}>
				<FeatureFlagProvider
          featureToggleDefinitions={featureToggleDefinitions}>

					<AuthModalProvider>
						<Head />
						<Body />
					</AuthModalProvider>
				</FeatureFlagProvider>
			</html>
		</I18nextProvider>);

}

export default withSentry(App);